import { render, staticRenderFns } from "./ruUser.vue?vue&type=template&id=bbc0cbb4&scoped=true&"
import script from "./ruUser.vue?vue&type=script&lang=js&"
export * from "./ruUser.vue?vue&type=script&lang=js&"
import style0 from "./ruUser.vue?vue&type=style&index=0&id=bbc0cbb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc0cbb4",
  null
  
)

export default component.exports